
let lastHtml = null;
function injectStyles() {
  const style = document.createElement("style");
  style.innerHTML = `
    /* Notification Popup */
    .vc-overlay {
      position: fixed;
      top: 30px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 99999;
      animation: vc-slide-down 0.4s ease;
    }
    .vc-box {
      background: #fff;
      border-radius: 16px;
      padding: 28px 32px;
      width: 340px;
      box-shadow: 0 20px 60px rgba(0,0,0,0.15);
      text-align: center;
      border-top: 4px solid #064b35;
    }
    .vc-icon {
      color: #064b35;
      margin-bottom: 12px;
      animation: vc-spin-once 0.6s ease-in-out;
    }
    .vc-title {
      margin: 0 0 8px;
      font-size: 18px;
      font-weight: 600;
      color: #222;
    }
    .vc-desc {
      font-size: 14px;
      color: #666;
      margin-bottom: 20px;
      line-height: 1.5;
    }
    .vc-btn-group {
      display: flex;
      gap: 10px;
      justify-content: center;
    }
    .vc-btn-reload {
      background: #064b35;
      color: white;
      border: none;
      padding: 10px 22px;
      border-radius: 8px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 600;
      transition: background 0.2s;
    }
    .vc-btn-reload:hover { background: #043526; }
    .vc-btn-dismiss {
      background: #f1f1f1;
      color: #555;
      border: none;
      padding: 10px 22px;
      border-radius: 8px;
      cursor: pointer;
      font-size: 14px;
      transition: background 0.2s;
    }
    .vc-btn-dismiss:hover { background: #e0e0e0; }
    /* Full Screen Loading */
    .vc-loading-screen {
      position: fixed;
      inset: 0;
      background: rgba(255,255,255,0.97);
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: vc-fade-in 0.3s ease;
    }
    .vc-loading-content {
      text-align: center;
    }
    .vc-spinner {
      width: 56px;
      height: 56px;
      border: 5px solid #90ee90;
      border-top-color: #064b35;
      border-radius: 50%;
      animation: vc-spin 0.9s linear infinite;
      margin: 0 auto 20px;
    }
    .vc-loading-label {
      font-size: 16px;
      font-weight: 500;
      color: #444;
      margin-bottom: 20px;
      animation: vc-pulse 1.2s ease-in-out infinite;
    }
    .vc-loading-track {
      width: 220px;
      height: 6px;
      background: #90ee90;
      border-radius: 10px;
      overflow: hidden;
      margin: 0 auto;
    }
    .vc-loading-fill {
      height: 100%;
      background: #064b35;
      border-radius: 10px;
      animation: vc-progress 6s ease-in-out forwards;
    }
    /* Animations */
    @keyframes vc-slide-down {
      from { transform: translateX(-50%) translateY(-40px); opacity: 0; }
      to   { transform: translateX(-50%) translateY(0); opacity: 1; }
    }
    @keyframes vc-slide-up-out {
      from { transform: translateX(-50%) translateY(0); opacity: 1; }
      to   { transform: translateX(-50%) translateY(-40px); opacity: 0; }
    }
    @keyframes vc-fade-in {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
    @keyframes vc-spin {
      to { transform: rotate(360deg); }
    }
    @keyframes vc-spin-once {
      from { transform: rotate(-180deg); opacity: 0; }
      to   { transform: rotate(0deg); opacity: 1; }
    }
    @keyframes vc-pulse {
      0%, 100% { opacity: 1; }
      50%       { opacity: 0.4; }
    }
    @keyframes vc-progress {
      0%   { width: 0%; }
      60%  { width: 80%; }
      100% { width: 95%; }
    }
  `;
  document.head.appendChild(style);
}
// ── Loading Screen ──
function showLoadingScreen() {
  const screen = document.createElement("div");
  screen.className = "vc-loading-screen";
  screen.innerHTML = `
    <div class="vc-loading-content">
      <div class="vc-spinner"></div>
      <p class="vc-loading-label">Loading new version...</p>
      <div class="vc-loading-track">
        <div class="vc-loading-fill"></div>
      </div>
    </div>
  `;
  document.body.appendChild(screen);
}
function showUpdateNotification() {
  if (document.querySelector(".vc-overlay")) return;
  const overlay = document.createElement("div");
  overlay.className = "vc-overlay";
  overlay.innerHTML = `
    <div class="vc-box">
      <div class="vc-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="23 4 23 10 17 10"></polyline>
          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
        </svg>
      </div>
      <h3 class="vc-title">New Version Available</h3>
      <p class="vc-desc">Please save your work and click OK to reload the latest version.</p>
      <div class="vc-btn-group">
        <button class="vc-btn-reload" id="vc-reload-btn">OK, Reload</button>
        <button class="vc-btn-dismiss" id="vc-dismiss-btn">Later</button>
      </div>
    </div>
  `;
  document.body.appendChild(overlay);
  document.getElementById("vc-reload-btn").addEventListener("click", () => {
    overlay.remove();
    showLoadingScreen();
    setTimeout(() => {
      window.location.reload();
    }, 6000);
  });
  document.getElementById("vc-dismiss-btn").addEventListener("click", () => {
    overlay.style.animation = "vc-slide-up-out 0.4s ease forwards";
    setTimeout(() => overlay.remove(), 400);
  });
}
async function fetchHtml() {
  const res = await fetch(`/?t=${Date.now()}`);
  return res.text();
}
function isLoggedIn() {
  return sessionStorage.getItem("token");
}
export async function startVersionPolling(intervalMs = 60000) {
  injectStyles();
  lastHtml = await fetchHtml();
  setInterval(async () => {
    try {
      if (!isLoggedIn()) return;
      const html = await fetchHtml();
      if (html !== lastHtml) {
        lastHtml = html;
        showUpdateNotification();
      }
    } catch (e) {
      // console.warn("Version check failed:", e);
    }
  }, intervalMs);
}